import { styled } from '@mui/material';

export const NumberCircle = styled('span')(({ theme }) => ({
  borderRadius: '9999999px',
  aspectRatio: '1 / 1',
  display: 'inline-grid',
  lineHeight: 1,
  placeContent: 'center',

  // Override these properties using `sx` prop to create required variant
  backgroundColor: theme.palette.background.contrast,
  color: theme.palette.common.white,
  fontSize: '1rem',
  height: '1.5em',
}));
